export default "__VITE_ASSET__BBxin1WF__"